import { PostType } from '@round/api';
import { GenericDropdownOption } from '../../utils/utils.types';

export const postTypeOptions: GenericDropdownOption<PostType>[] = [
    { value: 'tiktok_post', label: 'TikTok Post' },
    { value: 'instagram_post', label: 'Instagram Post' },
    { value: 'instagram_story', label: 'Instagram Story' },
    { value: 'youtube_post', label: 'YouTube Post' },
];
